global.jQuery = require('jquery');
window.$ = global.$ = global.jQuery;

global.validate = require('jquery-validation');
global.slick = require('slick-carousel/slick/slick.min');
global.chosen = require('chosen-npm/public/chosen.jquery.min');
global.swal = require('sweetalert/lib/sweetalert');

require('bootstrap-sass/assets/javascripts/bootstrap.min.js');
require('offline-plugin/runtime').install();

/**
 * Configs
 */
require('./config.jquery-validation');
require('./config.slick');
require('./config.chosen');

import ActivedFilter from './actived_filter';
import StickyMenu from './sticky_menu';
import FilterPortifolio from './filter_portifolio';

/**
 * JumpScroll do menu é do HeroSection
 */
require('./jump_scroll');

$(document).ready(function(){

  /**
  * Menu Fixed
  */
 $(window).on('resize scroll load', function(){
   new StickyMenu({
     position: $(window).scrollTop()
   });
 });

  /**
  * Filtros do portifolio ao clicar no menu
  * @type {ActivedFilter}
  */
  $('.portifolio-filter .action-filter').on('click', function(e){
    e.preventDefault();

    //get filter
    let activeFilter = new ActivedFilter($(this));
    let filterType = $(this).data('filter').toLowerCase();

    //apply filter
    let portifolio = new FilterPortifolio(filterType);
  });

  /**
  * jQuery Validation
  * @param  {[type]} 'form' [description]
  * @return {[type]}        [description]
  */
  $('form').validate();
  
  $('form.contact-form, form.palestra-form').submit(function(event){
	  event.preventDefault();
	  
	  $('.contend-shield').remove();

	  if(!$(this).valid()){
		  console.log("!valid");
		  return;
	  }
	  
	  var $btnSubmit = $(this.submit);
	  $btnSubmit.attr('disabled', 'disabled');
	  
	  var $shield = $('<div class="contend-shield"><div class="form-contact-message">Enviando ...</div>');
	  $('body').append($shield);
	  
	  $.ajax({
		  url: '/ajax/contato',
		  data: $(this).serialize(),
		  dataType: 'json',
		  type:'POST',	 
		  method:'POST',
	      success: function(response){
	    	  if(response.type == 'error'){
				  $('.form-contact-message')
				  .empty()
				  .html(response.message + " <a href='#fechar'>Fechar</a>")
				  .hide()
				  .fadeIn();
			  }
			  else{
				  $('.form-contact-message')
				  	.empty()
				  	.html(response.message + " <a href='#fechar'>Fechar</a>")
				  	.hide().fadeIn();
			  }
		  },
		  error: function(a, b, c){
			  try{
				  console.log(a);
				  console.log(b);
				  console.log(c);
			  }
			  catch(ex){}
			  
			 $('.form-contact-message')
			  	.empty()
			  	.html("Desculpe, o envio falhou! <a href='#fechar'>Fechar</a>")
			  	.fadeIn();
		  },
		  complete: function(a, b, c){
			  try{
				  console.log(a);
				  console.log(b);
				  console.log(c);
			  }
			  catch(ex){}
			  $(".form-contact-message a[href='#fechar']").click(function(event){
				  event.preventDefault();
			  });
			  
			  $btnSubmit.attr('disabled', false);
			  
			  $shield.click(function(){
				 $(this).remove(); 
			  });
		  }
	  });
	  
  });
  
  $("section.casais .items").click(function(){
	  var date = new Date();	
	  var p, i;
	  var r = parseInt(Math.random() * 10) + 1;
	  var $item = $(this).find(" > .item");
	  
	  var n = items.length;
	  do{
		  n--;
		  p = parseInt(Math.random() * 1000) % n;
		  items[p].count++;
//		  console.log(p + ":" + items[p].count);
	  }while(items[p].count > 2 && n > 0 );
	  
	  if(n == 0){
		  location.reload();
	  }
	  $item.empty().html(items[p].texto).hide().fadeIn() ;
	  
	  console.log(items);
  });
  
  

}); //jquery ready



//////////////////
// WEBPACK FOOTER
// ./src/javascripts/application.js
// module id = 6
// module chunks = 0